import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import AdminUsersPage from "../pages/AdminUsersPage";
import MainLayout from "../layouts/MainLayout";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
};

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout>
              <AdminUsersPage />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route path="/login" element={<LoginPage />} />
    </Routes>
  </Router>
);

export default AppRoutes;
